// extracted by mini-css-extract-plugin
module.exports = {"off":"animate_off__PFAMq","up":"animate_up__sB66Q","down":"animate_down__y_okS"};